<template>
    <label class="select-form" :for="id">
        <select :id="id">
            <option value="" disabled selected>{{ label }}</option>
            <option v-for="option in options" :value="option.value">
                {{ option.label }}
            </option>
        </select>
        <span class="select-form-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M6 9l6 6 6-6" />
            </svg>
        </span>
    </label>
</template>

<style lang="scss" scoped>
.select-form {
    position: relative;
    width: 100%;
    max-width: 220px;
    margin: 0;

    select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background: transparent;
        padding: 0 32px 0 16px;
        height: 32px;
        width: 100%;
        border-radius: 8px;
        border: 1px solid #E0E0E0;
        font-size: 14px;
        font-weight: 600;
        outline: none;
        color: #333;
        cursor: pointer;
    }

    .select-form-icon {
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translateY(-50%);
        color: #333;
        z-index: 1;
        pointer-events: none;
    }
}
</style>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    }
};
</script>
